<template>
  <div>
    <title>历史发货记录</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <!-- <header class="tabHeader">
        <p>
          <router-link :to="{name:'销售单管理'}">销售单管理</router-link>
          <router-link :to="{name:'历史发货记录'}">历史发货记录</router-link>
          <router-link :to="{name:'商品SKU列表'}" class="isActive">商品SKU列表</router-link>
        </p>
      </header> -->
      <CompanyTab :active="currentTit"></CompanyTab>
      <!--E 头部tab-->

      <!--S 商品SKU列表-->
      <!--S 检索-->      
      <el-form inline :model="formInline" class="searchForm">
        <el-form-item label="关键词">
          <el-input v-model="formInline.keywords" placeholder="请输入关键词" clearable></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="formInline.haveGoodSKU">
            <el-option label="全部" value=""></el-option>
            <el-option label="SKU为空" value="1"></el-option>
            <el-option label="SKU不为空" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select v-model="formInline.catetype" clearable>
            <el-option label="实物" :value="0">实物</el-option>
            <el-option label="兑换礼券" :value="1">兑换礼券</el-option>
            <el-option label="消费卡" :value="2">消费卡</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="serch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="exportd">导出</el-button>
        </el-form-item> 
      </el-form>
      <!--E 检索-->  
      <el-table :data="goodSKUData" ref="skuTable" class="comTable" border :maxHeight="tableHeight">         
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="商品信息" prop="goodsname" sortable>
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.goodsname+scope.row.kindinfo">{{scope.row.goodsname}}&nbsp;{{scope.row.kindinfo}}</p>
            <em class="blueColor" :title="scope.row.salesbarcode">SKU：{{scope.row.salesbarcode?scope.row.salesbarcode:'--'}}</em>
          </template>
        </el-table-column>
        <el-table-column label="商品类型" prop="catetype" sortable>
          <template slot-scope="scope">
            <p class="priceFont pdr70">{{scope.row.catetype | catetypeFilter}}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="规格名称" prop="kindinfo" sortable min-width="300">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.kindinfo||''">{{scope.row.kindinfo||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="商品SKU" prop="salesbarcode" sortable min-width="300">
          <template slot-scope="scope">
            <p>
              <span :id="scope.row.salesbarcode" :title="scope.row.salesbarcode">{{scope.row.salesbarcode?scope.row.salesbarcode:'--'}}</span>
              <em v-show="scope.row.salesbarcode" class="blueColor copyCode" data-clipboard-action="copy" :data-clipboard-target="`#${scope.row.salesbarcode}`" @click="handleCopy(scope.row.salesbarcode)">复制</em>
            </p>
          </template>
        </el-table-column> -->
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!--E 商品SKU列表-->
     <!-- S 分页 -->
      <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
     <!-- E 分页 -->
    </section>

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Clipboard from "clipboard";
import Api from "@/apis/api";
export default {
  name: 'GoodSKUList',
  data () {
    return {
      currentTit:2,
      pageTotal:0, //总数
      currentPage:1, // 页数
      pageSize:30, // 条数
      formInline:{
        keywords:'',
        haveGoodSKU:'0',
        catetype: null, // 商品类型
      },
      goodSKUData:[],//商品SKU列表
      tableHeight: window.innerHeight * 0.8, //表格动态高度   
    }
  },
  filters: {
    catetypeFilter(val) {
      if(val == 0) {
        return '实物';
      } else if(val == 1) {
        return '兑换礼券';
      } else if(val == 1) {
        return '消费卡';
      }
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
  },
  watch: {
  },
  methods: {
    // 复制链接
    handleCopy(sku) {
      var clipboard = new Clipboard(".copyCode");
      clipboard.on("success", e => {
        Message({
          type: 'success',
          message: '已成功复制到剪贴板!',
          // offset:200
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        Message({
          type: 'warning',
          message: '该浏览器不支持一键复制!'
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.skuTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      // console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
    // 分页
    nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.$refs.skuTable.bodyWrapper.scrollTop = 0;
      this.getGoodsSkuList();
    },
    serch(){
      this.getGoodsSkuList();
    },
    getGoodsSkuList(){
       let param ={
           isskuempty:this.formInline.haveGoodSKU?Number(this.formInline.haveGoodSKU):'',
           keyword:this.formInline.keywords,
           catetype: this.formInline.catetype!==''?this.formInline.catetype:null,
           pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
            }
       }
      Api.GET_GOODSSKULIST(param).then(res =>{
          if(res.data.status=="200"){
            this.goodSKUData = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
          }else{
            this.goodSKUData = [];
            this.pageTotal = 0;
          }
      })
    },
    exportd(){
      let param ={
        isskuempty:this.formInline.haveGoodSKU?Number(this.formInline.haveGoodSKU):'',
        keyword:this.formInline.keywords,
        catetype: this.formInline.catetype!==''?this.formInline.catetype:null,
      }
       Api.EXPORTGOODSSKULIST(param).then(res =>{
         if(res.data.status=="200"){
           window.location.href =res.data.data;
         }else{
           this.$message.error(res.data.message)
         }
       })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    this.getGoodsSkuList();
    setTimeout(() => {
      this.getHeight();
    }, 200);
    
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.searchForm {padding-top:64px;}
/* .comTable >>> .el-table__header tr th:nth-child(2) >.cell{padding-right:70px;text-align: right;}
.textFl.pdr70 {width:auto; padding-right:70px;text-align: right;} */
.copyCode {padding-left:10px; cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/GoodSKUList.vue